import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import FindReplaceOutlinedIcon from '@material-ui/icons/FindReplaceOutlined';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});

class QAErrorRow extends Component {
	constructor() {
		super();
		this.state= {
			processing: false
		}
		this.click = this.click.bind(this);
		this.handleCheckbox = this.handleCheckbox.bind(this);
	}
	
	click(){
		if(this.props.goToSegment !== null){
			this.props.goToSegment(this.props.position);
		}
	}
	
	handleCheckbox(e){
		//console.log("handleCheckbox");
		this.props.switchAction(this.props.id, e.target.checked ? 1:0);
	}

	render() {
//		console.log(this.props.goToSegment);
		return (
			<TableRow hover key={this.props.id} onClick={this.click}>
			{this.props.dropdown && <TableCell></TableCell>}
			{this.props.switchAction && <TableCell>
										<Checkbox
											checked={this.props.enabled>0}
											value={"er_"+this.props.id}
											color="primary"
											onChange={this.handleCheckbox}
										/>
									</TableCell>}
			<TableCell>{this.props.position+1}</TableCell>
			<TableCell>{this.props.severity}</TableCell>
			<TableCell>{this.props.category}</TableCell>
			<TableCell><div dangerouslySetInnerHTML={{ __html: this.props.description}}></div></TableCell>
			</TableRow>
		);
	}
}

export default withStyles(styles)(QAErrorRow);